import { defineMessages } from 'react-intl';

const messages = defineMessages({
  privacy: {
    id: 'authTemplates.footer.privacy',
    defaultMessage: 'Privacy Statement',
    description: 'Footer privacy statement link',
  },
  termsAndCondition: {
    id: 'authTemplates.footer.termsAndCondition',
    defaultMessage: 'Terms of Use',
    description: 'Footer terms of use link',
  },
  cookies: {
    id: 'authTemplates.footer.cookies',
    defaultMessage: 'Cookie Policy',
    description: 'Footer cookie policy link',
  },
  cookiePreferences: {
    id: 'authTemplates.footer.cookiePreferences',
    defaultMessage: 'Cookie Preferences',
    description: 'Footer cookie preferences button',
  },
  opensInNewTab: {
    id: 'authTemplates.footer.opensInNewTab',
    defaultMessage: '(opens in a new tab)',
    description: 'Text indicating a link opens in a new browser tab',
  },
  websiteOpensInNewTab: {
    id: 'authTemplates.footer.websiteOpensInNewTab',
    defaultMessage: 'Website (opens in a new tab)',
    description: 'Text indicating a link opens in a new browser tab',
  },
  copyright: {
    id: 'authTemplates.footer.copyright',
    defaultMessage: '© Copyright 2025 AGCO Corporation. All Rights Reserved.',
    description: 'Footer copyright details',
  },
  copyright1: {
    id: 'authTemplates.footer.copyright.1',
    defaultMessage: '© Copyright 2025 AGCO Corporation.',
    description: 'Footer copyright details part 1',
  },
  copyright2: {
    id: 'authTemplates.footer.copyright.2',
    defaultMessage: 'All Rights Reserved.',
    description: 'Footer copyright details part 2',
  },
});

export default messages;
